import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { SVODEntitlement, TVODEntitlement } from '../../../entity/interface/iEntitlements';

export interface IGetAllUseCase {
    execute(
        apiKey: string,
        username: string,
        token: string
    ): Promise<{
        entitledSvods: SVODEntitlement[];
        entitledTvods: TVODEntitlement[];
    }>;
}

export class GetAllUseCase implements IGetAllUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getAllRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        username: string,
        token: string
    ): Promise<
        | {
              entitledSvods: SVODEntitlement[];
              entitledTvods: TVODEntitlement[];
          }
        | any
    > {
        const response = await this.getAllRepository.getAll(apiKey, username, token);
        return response.data;
    }
}
